module.exports = __webpack_public_path__ + "static/media/group_19@2x.91961401.jpg";